// last one is Caraganier de Sibérie - repeated x times
const treeList = [
	"Framboisier",
	"Genévrier",
	"Parasolier",
	"Arbre de soie",
	"Aralia de Californie",
	"Aubépine",
	"Kaki",
	"Jasmin de Madagascar",
	"Argousier",
	"Pacanier",
	"Abricotier",
	"Madrone du pacifique",
	"Acacia",
	"Arbre aux lanternes",
	"Arbousier",
	"Kiwi",
	"Cotinus",
	"Epicéa",
	"Platane",
	"Arbre aux anémones",
	"Liane de jade",
	"Eucalyptus",
	"Fusain ailé",
	"Latanier",
	"Citronnier",
	"Abelia",
	"Prunier",
	"Casseille",
	"Dragonnier",
	"Cédratier",
	"Pommier",
	"Acerola",
	"Chèvrefeuille",
	"Hévéa",
	"Oranger",
	"Amandier",
	"Cèdre",
	"Griottier",
	"Cassissier",
	"Frangipanier",
	"Olivier",
	"Rhubarbe",
	"Orme",
	"Noisetier",
	"Sorbier",
	"Mandarinier",
	"Frêne",
	"Myrte",
	"Baobab",
	"Caroubier",
	"Pavier rouge",
	"Noyer",
	"Mûrier platane",
	"Pistachier",
	"Eglantier",
	"Giroflier",
	"Cocotier",
	"Cyprès",
	"Grenadier",
	"Erable",
	"Acajou",
	"Bergamotier",
	"Avocatier",
	"Cognassier",
	"Murier blanc",
	"Agave",
	"L'Arbre corail",
	"Arbre de judé",
	"Camélia",
	"Cerisier",
	"Charme",
	"Cacaoyer",
	"Chêne",
	"Adenia",
	"Arbre au caramel",
	"Arbre aux perles",
	"Longanier",
	"Laurier",
	"Hortensia",
	"Palmier",
	"Néflier",
	"Caféier",
	"Poirier",
	"Kauri",
	"Mirabellier",
	"Févier",
	"Hydrangea",
	"Filaire",
	"Davidia",
	"Arbre orchidée",
	"Henné",
	"Bananier",
	"Hoya",
	"Vinaigrier",
	"Gommier",
	"Tsuga",
	"Arbre aux faisans",
	"Catalpa",
	"Bouleau",
	"Pamplemoussier",
	"Hibiscus",
	"Arbre à miel",
	"Lilas",
	"Bigaradier",
	"Virgilier",
	"Pin",
	"Châtaignier",
	"Bambou",
	"Figuier",
	"Troéne",
	"Bougainvillier",
	"Mélèze",
	"Bourdaine",
	"Canneberge",
	"Fragon",
	"Nopal",
	"Magnolia",
	"Calocèdre",
	"Muscadier",
	"Pêcher",
	"Peuplier",
	"Groseillier",
	"Mimosa",
	"Hêtre",
	"Combava",
	"Sapin",
	"Azerolier",
	"Bibacier",
	"Saule",
	"Tamarinier",
	"Câprier",
	"Pin parasol",
	"Saule pleureur",
	"Cactus",
	"Tilleul",
	"Quercus",
	"Vigne",
	"Carambolier",
	"Séquoia",
	"Cannelier",
	"Poncirier",
	"Viorne",
	"Teck",
	"Aucuba",
	"Sureau",
	"Séquoia géant",
	"Framboisier",
	"Genévrier",
	"Thuya",
	"Parasolier",
	"Adenium",
	"Kiwaï",
	"Hamamélis",
	"Arbre de soie",
	"Aralia de Californie",
	"Cherimolier",
	"Jacaranda",
	"Aubépine",
	"Kalopanax",
	"Glycine",
	"Forsythia",
	"Kaki",
	"Argousier",
	"Notro",
	"Paulownia",
	"Iochrome",
	"Hiba",
	"Pacanier",
	"Abricotier",
	"Osmophore",
	"Nerprun",
	"Arbre du clergé",
	"Niaouli",
	"Amélanchier",
	"Liquidambar",
	"Photinia",
	"Aulne",
	"Acacia",
	"Aralia elata",
	"Papayer",
	"Nashi",
	"Kolkwitzia",
	"Arbousier",
	"Hièble",
	"Kiwi",
	"Cotinus",
	"Epicéa",
	"Platane",
	"Arbre aux anémones",
	"Liane de jade",
	"Pieris",
	"Eucalyptus",
	"Fusain ailé",
	"Merisier",
	"Ailante",
	"Latanier",
	"Citronnier",
	"Araucaria",
	"Mehonia",
	"Amorpha",
	"Ragouminier",
	"Kaloupilé",
	"Abelia",
	"Prunier",
	"Pyracanthe",
	"Casseille",
	"Dragonnier",
	"Cédratier",
	"Pommier",
	"Acerola",
	"Metrosideros",
	"Mûre de Logan",
	"Libocèdre",
	"Chèvrefeuille",
	"Jojoba",
	"Hévéa",
	"Oranger",
	"Amandier",
	"Cèdre",
	"Ceiba",
	"Griottier",
	"Cassissier",
	"Frangipanier",
	"Olivier",
	"Stachyurus",
	"Rhubarbe",
	"Erhetia",
	"Sapotillier",
	"Orme",
	"Gattilier",
	"Sassafra albidum",
	"Noisetier",
	"Sorbier",
	"Cornouiller",
	"Mandarinier",
	"Frêne",
	"Myrte",
	"Baobab",
	"Savonnier de Chine",
	"Jujubier",
	"Epinette",
	"Caroubier",
	"Pavier rouge",
	"Anacardier",
	"Noyer",
	"Pistachier",
	"Prosopis alba",
	"Yucca",
	"Parrotia",
	"Bélombra",
	"Xanthoceras",
	"Cormier",
	"Rosa canina",
	"Eglantier",
	"Giroflier",
	"Houx",
	"Pepino",
	"Idesia",
	"Aporocactus",
	"Nectarinier",
	"Berberis",
];

export default treeList;